module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.6.18.0@babel-runtime/core-js/json/stringify.js
// module id = 7
// module chunks = 2